export const typeProps = { label: 'name', value: 'id' }